import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {_imagenLogo} from '../imagenesBase64/logo'
import Swal from 'sweetalert2';
import {transformarIso8601,fechaActual} from '../Helpers/fechas';


const bkmonto = '';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function imprimir(datos, nombrePDF, tituloPDF,callbackMap,arrayCampos,orientacion,parametros){
    try{

        Swal.fire({
            html: 'Buscando...',
            timer: 600,
            onBeforeOpen: () => {
                Swal.showLoading()
            },
        }).then(data=>{
            generarDocumento(datos, nombrePDF, tituloPDF,callbackMap,arrayCampos,orientacion ? orientacion : 'portrait',parametros)
        })
    }catch(err){

            const mensaje_html = `<p>Hubo un error al generar el documento</p><p>${err}</p>`

            Swal.fire({
                html:mensaje_html,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })
        }
}

function imprimirSubtotalRubroValor(totalNumerico){
    const total_formateado = Number(totalNumerico||0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return {
        fontSize: 10,
        bold:true,
        margin:[0,10,0,10],
        columns: [
            { width: 50, text: 'SUBTOTAL' },
            { width: 395, canvas: [{ type: 'line', x1: 0, y1: 5, x2: 395, y2: 5, lineWidth: 0.5, lineColor: 'black' }] },
            {
                width: 85,
                background:bkmonto, alignment:'right',
                table: { widths:[85], body: [[{text: total_formateado, alignment:'right'}]] }
            }
        ]
    };
}

function generarDocumento(datos,nombrePDF, tituloPDF,callbackMap,arrayCampos,orientacion,parametros) {

    // Orden estable por rubro (A–Z), preservando el orden original dentro del mismo rubro
    const datosOrdenados = (datos || [])
        .map((v, idx) => ({ v, idx }))
        .sort((a, b) => {
            const ra = (a.v?.rubro || '').toString();
            const rb = (b.v?.rubro || '').toString();
            const cmpR = ra.localeCompare(rb, 'es', { sensitivity: 'base' });
            if (cmpR !== 0) return cmpR;
            return a.idx - b.idx; // estable: respeta orden original dentro del rubro
        })
        .map(x => x.v);

    // Construcción del cuerpo: MISMAS filas, se agrega solo el subtotal por rubro
    const cuerpo_del_reporte = [];
    let rubroActual = null;
    let subtotalRubro = 0;

    datosOrdenados.forEach((item, index, vector) => {
        // Si cambia el rubro, imprimir subtotal del grupo anterior
        if (rubroActual !== null && item.rubro !== rubroActual) {
            cuerpo_del_reporte.push(imprimirSubtotalRubroValor(subtotalRubro));
            subtotalRubro = 0;
        }

        // Fila existente (sin cambios de estilo ni tamaños)
        cuerpo_del_reporte.push([
            parametros.total_caja ? imprimirTotalCaja(item,index,vector) : '',
            parametros.total_diario ? imprimirTotalDiario(item,index,vector) : '',
            parametros.total_mensual ? imprimirTotalMes(item,index,vector) : '',
            parametros.total_año ? imprimirTotalAño(item,index,vector) : '',
            {stack: [
                { layout: 'noBorders',
                  style:'estilo_tabla',
                  table:{
                      widths: [40,130,70,185, 85],
                      body:[[
                          transformarIso8601(item.fecha),
                          item.proveedor,
                          `${item.tipo_compr} ${item.nro_compr}`,
                          item.descripcion,
                          {text:item.monto,alignment: 'right'}
                      ]]
                  }
                },
                {style:'estilo_columna', columns:[
                    {width: 130,margin:[48,0,0,0],text:item.caja},
                    {width: 200,margin:[57,0,0,0],text:item.rubro}
                ]},
                {style:'estilo_columna',columns:[{width: 250,margin:[48,0,0,0],text:item.fondo}]},
                {style:'estilo_columna',columns:[{width: 500,margin:[48,0,0,0],text:`${item.datos_bcrios}\n\n`}]},
                {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 0.5, dash: {length: 1, space: 2}, lineColor: 'black' }]}
            ], unbreakable: true},
            // Totales finales (se mantienen)
            index==vector.length-1 && parametros.total_caja ? imprimirTotalCajaFinal(item,index,vector) : '',
            index==vector.length-1 && parametros.total_diario ? imprimirTotalDiarioFinal(item,index,vector) : '',
            index==vector.length-1 && parametros.total_mensual ? imprimirTotalMesFinal(item,index,vector) : '',
            index==vector.length-1 && parametros.total_año ? imprimirTotalAñoFinal(item,index,vector) : ''
            // NOTA: Total general se imprime después del último subtotal
        ]);

        // acumular subtotal del rubro
        subtotalRubro += (item?.monto_numerico || 0);
        rubroActual = item.rubro;

        // Al final del vector cerramos el último rubro
        if (index === vector.length - 1) {
            cuerpo_del_reporte.push(imprimirSubtotalRubroValor(subtotalRubro));
        }
    });

    // DocDefinition: se mantiene HEADER/FOOTER y estructura EXACTAMENTE como indicaste
    var docDefinition = {
        pageOrientation: 'portrait',//orientacion,
        pageMargins: [25, 110, 25, 50], // el margen de 100 para el top es necesario para que la imagen de la cabecera no se solape con el contenido
        header: function(currentPage, pageCount, pageSize) {
            // you can apply any logic and return any valid pdfmake element
        
            if (currentPage>1){
                return [
                    { text: tituloPDF, alignment: 'left' ,margin:[20,20,0,50] },
                    {
                        width: pageSize.width,
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: pageSize.width, y2: 5, lineWidth: 1,lineColor: 'black' }],
                    } 
                  ]
            }else{
                return  [
                    { margin:[10,30],
                        columns:[
                            {
                            image: _imagenLogo,
                            width: 50,
                            alignment: 'left',
                        },
                        {text:'Unión de las Asambleas de Dios - ' + (parametros?.tituloReporte || 'Egresos cronológicos'),margin:[20,0]}
                        ]   
                    },
                    {text:tituloPDF,alignment: 'left',margin:[10,0,0,0]},
                    {
                        width: pageSize.width,
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: pageSize.width, y2: 5, lineWidth: 1,lineColor: 'black' }],
                    }    
                ]
            }
          },
        footer: function (currentPage, pageCount, pageSize) { 
            return {
                margin: [0, 30, 30, 0], //el margin inferior de la página (pageMargins) tiene que ser tal que sea consistente con el margen superior del footer, si no el footer desaparece
                table: {
                    
                    widths: ['*','*'],
                    body: [
                        [{text:fechaActual('DD/MM/YYYY'),alignment: 'right',fontSize: 8},{ text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'right', fontSize: 8 }]
                    ]
                },
                layout: 'noBorders'
                
                    } 
         },
        content: [
            /*{
                image: _imagenLogo,
                width: 70,
                alignment: 'center',
            },
            {
                text: `Test`, margin: tituloPDF==""? [0, 0] : [2,20], style: 'center'
            },*/

            cuerpo_del_reporte,
            // Al final, el total general (mismo formato existente)
            imprimirTotalGeneral(datosOrdenados[datosOrdenados.length-1], datosOrdenados.length-1, datosOrdenados)
        ],
        styles: {
            header: {
                alignment: 'right'
            },
            center: {
                alignment: 'center',
                decoration: 'underline'
            },
            estilo_columna:{
                fontSize: 8,          
                characterSpacing:-0.3
            },
            estilo_tabla:{
                fontSize: 8,     
                characterSpacing:-0.3,
                margin: [0, 10, 0, 0]
            },
            anotherStyle: {
                fontSize: 15,
                bold: true,
            },
            body: {
                lineHeight: 1.5
            },
            tableHeader: {
                bold:true,
                fontSize:12
            }
        },
        images: {
            building: 'data:/Content/img/logo1.jpg'
        }
    };

    pdfMake.createPdf(docDefinition).open()
}

function imprimirTotalDiario(item,index,vector){
    //esta función analiza si corresponde imprimir un total
    // evalúa si cambia de fecha preguntando si la fecha del registro actual
    // es diferente a la fecha del registro anterior
    // si es diferente calcula el total de todos los registros que tengan
    // la misma fecha del último registro
    // Si es la misma fecha el registro actual que el anterior no imprime total
    // si el vector tiene solo 1 registro imprime el total directamente tomando el monto tal como está en ese único registro
    // si el vector tiene 2 filas o mas evalúa la fecha cuando el indice es mayor a 0
    // si el indice es cero no imprime porque no tiene contra qué comparar
    // No comparamos con el item.fecha sino que antes de comparar la transformamos a un formato DD/MM/YYYY
    // el campo fecha viene en un formato que contiene horas minutos y segundos por eso
    // si no se convierte el formato aunque tenga la misma fecha daría que son diferentes fechas
    // por otro lado el campo monto es un string que tiene formato moneda
    // por eso la totalización se hace sobre el campo monto_numerico

    if(vector.length>1){
        if (index>0){
            if (transformarIso8601(vector[index-1].fecha)==transformarIso8601(item.fecha)){
                return {text:''}
            }else{
                const total = vector.filter(i=>transformarIso8601(i.fecha)==transformarIso8601(vector[index-1].fecha)).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
                const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                const fecha = new Date(vector[index-1].fecha);
                //return {text:`Total fecha ${transformarIso8601(vector[index-1].fecha)}${total_formateado}`}
                return 	{
                    fontSize: 10,
                    bold:true,
                    margin:[0,10,0,10],
                    columns: [
                        {
                            width: 50,
                            text: 'TOTAL'
                        },
                        {
                            width: 60,
                            text: `Año  ${fecha.getFullYear()}`
                        },
                        {
                            width: 60,
                            text: `Mes  ${fecha.getMonth() + 1}`
                        },
                        {
                            width: 60,
                            text: `Día  ${fecha.getDate()}`
                        },
                        {
                            width: 315,
                            canvas: [{ type: 'line', x1: 0, y1: 5, x2: 305, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                        },
                        {
                            width: 85,
                            background:bkmonto,alignment:'right',
                            table: {
                                widths:[85],
                                body: [
                                    [{text:total_formateado,alignment:'right'}],
                                ]
                            }
                        },
                    ]
                }
            }
        }else{
            return {text:''}
        }
    }else if (vector.length==1){
        const fecha = new Date(item.fecha);
        return {stack:[{
            fontSize: 10,
            bold:true,
            margin:[0,10,0,10],
            columns: [
                {
                    width: 50,
                    text: 'TOTAL'
                },
                {
                    width: 60,
                    text: `Año  ${fecha.getFullYear()}`
                },
                {
                    width: 60,
                    text: `Mes  ${fecha.getMonth() + 1}`
                },
                {
                    width: 60,
                    text: `Día  ${fecha.getDate()}`
                },
                {
                    width: 220,
                    canvas: [{ type: 'line', x1: 0, y1: 5, x2: 220, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                },
                {
                    width: 60,
                    background:bkmonto,alignment:'right',
                    table: {
                        widths:[60],
                        body: [
                            [{text:item.monto,alignment:'right'}],
                        ]
                    }
                },
            ]
        }],unbreakable:true}
    }else{
        return {text:''}
    }

}


function imprimirTotalDiarioFinal(item,index,vector){
        const total = vector.filter(i=>transformarIso8601(i.fecha)==transformarIso8601(item.fecha)).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
       // return {text:`Total fecha ${transformarIso8601(vector[index-1].fecha)}${total_formateado}`}
        const fecha = new Date(item.fecha);
        return {stack:[{
            fontSize: 10,
            bold:true,
            margin:[0,10,0,10],
            columns: [
                {
                    width: 50,
                    text: 'TOTAL'
                },
                {
                    width: 60,
                    text: `Año  ${fecha.getFullYear()}`
                },
                {
                    width: 60,
                    text: `Mes  ${fecha.getMonth() + 1}`
                },
                {
                    width: 60,
                    text: `Día  ${fecha.getDate()}`
                },
                {
                    width: 240,
                    canvas: [{ type: 'line', x1: 0, y1: 5, x2: 240, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                },
                {
                    width: 60,
                    background:bkmonto,alignment:'right',
                    table: {
                        widths:[60],
                        body: [
                            [{text:item.monto,alignment:'right'}],
                        ]
                    }
                },
            ]
        }],unbreakable:true }   
    }





function imprimirTotalCaja(item,index,vector){
    //esta función analiza si corresponde imprimir un total
    // evalúa si cambia de fecha preguntando si la fecha del registro actual
    // es diferente a la fecha del registro anterior
    // si es diferente calcula el total de todos los registros que tengan
    // la misma fecha del último registro
    // Si es la misma fecha el registro actual que el anterior no imprime total
    // si el vector tiene solo 1 registro imprime el total directamente tomando el monto tal como está en ese único registro
    // si el vector tiene 2 filas o mas evalúa la fecha cuando el indice es mayor a 0
    // si el indice es cero no imprime porque no tiene contra qué comparar
    // No comparamos con el item.fecha sino que antes de comparar la transformamos a un formato DD/MM/YYYY
    // el campo fecha viene en un formato que contiene horas minutos y segundos por eso
    // si no se convierte el formato aunque tenga la misma fecha daría que son diferentes fechas
    // por otro lado el campo monto es un string que tiene formato moneda
    // por eso la totalización se hace sobre el campo monto_numerico

    if(vector.length>1){
        if (index>0){
            if (transformarIso8601(vector[index-1].fecha)==transformarIso8601(item.fecha)){
                if (vector[index-1].caja==item.caja){
                    return {text:''}
                }else{
                    const total = vector.filter(i=>transformarIso8601(i.fecha)==transformarIso8601(vector[index-1].fecha) && i.caja==vector[index-1].caja).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
                    const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                    const fecha = new Date(vector[index-1].fecha);
//                    return {text:`Total caja ${vector[index-1].caja}${total_formateado}`}
                    return {stack:[{
                        fontSize: 10,
                        bold:true,
                        margin:[0,10,0,10],
                        columns: [
                            {
                                width: 50,
                                text: 'TOTAL'
                            },
                            {
                                width: 60,
                                text: `Año  ${fecha.getFullYear()}`
                            },
                            {
                                width: 60,
                                text: `Mes  ${fecha.getMonth() + 1}`
                            },
                            {
                                width: 60,
                                text: `Día  ${fecha.getDate()}`
                            },
                            {
                                width: 100,
                                text: `${vector[index-1].caja}`
                            },
                            {
                                width: 95,
                                canvas: [{ type: 'line', x1: 0, y1: 5, x2: 95, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                            },
                            {
                                width: 85,
                                background:bkmonto,alignment:'right',
                                table: {
                                    widths:[85],
                                    body: [
                                        [{text:total_formateado,alignment:'right'}],
                                    ]
                                }
                            },
                        ]
                    }],unbreakable:true}              

                
                }
            }else{
                // si hubo cambio de fecha siempre calculo la caja
                    const total = vector.filter(i=>transformarIso8601(i.fecha)==transformarIso8601(vector[index-1].fecha) && i.caja==vector[index-1].caja).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
                    const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                    //return {text:`Total caja ${vector[index-1].caja}${total_formateado}`}
                    const fecha = new Date(vector[index-1].fecha);

                    return 	{stack:[{
                        fontSize: 10,
                        bold:true,
                        margin:[0,10,0,10],
                        columns: [
                            {
                                width: 50,
                                text: 'TOTAL'
                            },
                            {
                                width: 60,
                                text: `Año  ${fecha.getFullYear()}`
                            },
                            {
                                width: 60,
                                text: `Mes  ${fecha.getMonth() + 1}`
                            },
                            {
                                width: 60,
                                text: `Día  ${fecha.getDate()}`
                            },
                            {
                                width: 100,
                                text: `${vector[index-1].caja}`
                            },
                            {
                                width: 95,
                                canvas: [{ type: 'line', x1: 0, y1: 5, x2: 95, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                            },
                            {
                                width: 85,
                                background:bkmonto,alignment:'right',
                                table: {
                                    widths:[85],
                                    body: [
                                        [{text:total_formateado,alignment:'right'}],
                                    ]
                                }
                            },
                        ]
                    }],unbreakable:true}
            }
        }else{
            return {text:''}
        }
    }else if (vector.length==1){
        const fecha = new Date(item.fecha);

        return 	{stack:[{
            fontSize: 10,
            bold:true,
            margin:[0,10,0,10],
            columns: [
                {
                    width: 50,
                    text: 'TOTAL'
                },
                {
                    width: 60,
                    text: `Año  ${fecha.getFullYear()}`
                },
                {
                    width: 60,
                    text: `Mes  ${fecha.getMonth() + 1}`
                },
                {
                    width: 60,
                    text: `Día  ${fecha.getDate()}`
                },
                {
                    width: 100,
                    text: `${vector[index-1].caja}`
                },
                {
                    width: 120,
                    canvas: [{ type: 'line', x1: 0, y1: 5, x2: 120, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                },
                {
                    width: 60,
                    background:bkmonto,alignment:'right',
                    table: {
                        widths:[60],
                        body: [
                            [{text:item.monto,alignment:'right'}],
                        ]
                    }
                },
            ]
        }],unbreakable:true}
    }else{
        return {text:''}
    }

}

function imprimirTotalMes(item,index,vector){

    if(vector.length>1){
        if (index>0){
            if (transformarIso8601(vector[index-1].fecha,'MM')==transformarIso8601(item.fecha,'MM')){
                return {text:''}
            }else{
                const total = vector.filter(i=>transformarIso8601(i.fecha,'MM')==transformarIso8601(vector[index-1].fecha,'MM')).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
                const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                const fecha = new Date(vector[index-1].fecha);
               // return {text:`Total mes ${transformarIso8601(vector[index-1].fecha,'MM')} ${total_formateado}`}
                return {stack:[{
                    fontSize: 10,
                    bold:true,
                    margin:[0,10,0,10],
                    columns: [
                        {
                            width: 50,
                            text: 'TOTAL'
                        },
                        {
                            width: 60,
                            text: `Año  ${fecha.getFullYear()}`
                        },
                        {
                            width: 60,
                            text: `Mes  ${fecha.getMonth() + 1}`
                        },
                        {
                            width: 315,
                            canvas: [{ type: 'line', x1: 0, y1: 5, x2: 305, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                        },
                        {
                            width: 85,
                            background:bkmonto,alignment:'right',
                            table: {
                                widths:[85],
                                body: [
                                    [{text:item.monto,alignment:'right'}],
                                ]
                            }
                        },
                    ]
                }],unbreakable:true}
            }
        }else{
            return {text:''}
        }
    }else if (vector.length==1){
        const fecha = new Date(item.fecha);
        return {stack:[{
            fontSize: 10,
            bold:true,
            margin:[0,10,0,10],
            columns: [
                {
                    width: 50,
                    text: 'TOTAL'
                },
                {
                    width: 60,
                    text: `Año  ${fecha.getFullYear()}`
                },
                {
                    width: 60,
                    text: `Mes  ${fecha.getMonth() + 1}`
                },
                {
                    width: 280,
                    canvas: [{ type: 'line', x1: 0, y1: 5, x2: 280, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                },
                {
                    width: 60,
                    background:bkmonto,alignment:'right',
                    table: {
                        widths:[60],
                        body: [
                            [{text:item.monto,alignment:'right'}],
                        ]
                    }
                },
            ]
        }],unbreakable:true}
    }else{
        return {text:''}
    }

}

function imprimirTotalAño(item,index,vector){

    if(vector.length>1){
        if (index>0){
            if (transformarIso8601(vector[index-1].fecha,'YYYY')==transformarIso8601(item.fecha,'YYYY')){
                return {text:''}
            }else{
                const total = vector.filter(i=>transformarIso8601(i.fecha,'YYYY')==transformarIso8601(vector[index-1].fecha,'YYYY')).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
                const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                //return {text:`Total año ${transformarIso8601(vector[index-1].fecha,'YYYY')} ${total_formateado}`}
                const fecha = new Date(vector[index-1].fecha);
    
                return 	{
                    fontSize: 10,
                    bold:true,
                    margin:[0,10,0,10],
                    columns: [
                        {
                            width: 50,
                            text: 'TOTAL'
                        },
                        {
                            width: 100,
                            text: `${vector[index-1].caja}`
                        },
                        {
                            width: 95,
                            canvas: [{ type: 'line', x1: 0, y1: 5, x2: 95, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                        },
                        {
                            width: 85,
                            background:bkmonto,alignment:'right',
                            table: {
                                widths:[85],
                                body: [
                                    [{text:item.monto,alignment:'right'}],
                                ]
                            }
                        },
                    ]
                }
            }
        }else{
            return {text:''}
        }
    }else if (vector.length==1){
        const fecha = new Date(item.fecha);
    
        return 	{
            fontSize: 10,
            bold:true,
            margin:[0,10,0,10],
            columns: [
                {
                    width: 50,
                    text: 'TOTAL'
                },
                {
                    width: 60,
                    text: `Año  ${fecha.getFullYear()}`
                },
                {
                    width: 340,
                    canvas: [{ type: 'line', x1: 0, y1: 5, x2: 330, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                },
                {
                    width: 60,
                    background:bkmonto,alignment:'right',
                    table: {
                        widths:[60],
                        body: [
                            [{text:item.monto,alignment:'right'}],
                        ]
                    }
                },
            ]
        }
    }else{
        return {text:''}
    }
}

function imprimirTotalCajaFinal(item,index,vector){
    const total = vector.filter(i=>transformarIso8601(i.fecha)==transformarIso8601(item.fecha) && i.caja==item.caja).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
    const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
   // return {text:`Total caja ${vector[index-1].caja}${total_formateado}`}

    const fecha = new Date(item.fecha);
                        return 	{
                            fontSize: 10,
                            bold:true,
                            margin:[0,10,0,10],
                            columns: [
                                {
                                    width: 50,
                                    text: 'TOTAL'
                                },
                                {
                                    width: 60,
                                    text: `Año  ${fecha.getFullYear()}`
                                },
                                {
                                    width: 60,
                                    text: `Mes  ${fecha.getMonth() + 1}`
                                },
                                {
                                    width: 60,
                                    text: `Día  ${fecha.getDate()}`
                                },
                                {
                                    width: 100,
                                    text: `${vector[index-1].caja}`
                                },
                                {
                                    width: 115,
                                    canvas: [{ type: 'line', x1: 0, y1: 5, x2: 115, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                                },
                                {
                                    width: 85,
                                    background:bkmonto,alignment:'right',
                                    table: {
                                        widths:[85],
                                        body: [
                                            [{text:total_formateado,alignment:'right'}],
                                        ]
                                    }
                                },
                            ]
                        }

}

function imprimirTotalMesFinal(item,index,vector){
    const total = vector.filter(i=>transformarIso8601(i.fecha,'MM')==transformarIso8601(item.fecha,'MM')).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
    const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    //return {text:`Total mes ${transformarIso8601(item.fecha,'MM')} ${total_formateado}`}
    const fecha = new Date(item.fecha);
    
     return 	{
         fontSize: 10,
         bold:true,
         margin:[0,10,0,10],
         columns: [
             {
                 width: 50,
                 text: 'TOTAL'
             },
             {
                 width: 60,
                 text: `Año  ${fecha.getFullYear()}`
             },
             {
                 width: 60,
                 text: `Mes  ${fecha.getMonth() + 1}`
             },
             {
                 width: 275,
                 canvas: [{ type: 'line', x1: 0, y1: 5, x2: 275, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
                },
             {
                 width: 85,
                 background:bkmonto,alignment:'right',
                 table: {
                    widths:[85],
                    body: [
                        [{text:total_formateado,alignment:'right'}],
                    ]
                }
             },
         ]
     }
}

function imprimirTotalAñoFinal(item,index,vector){
    const total = vector.filter(i=>transformarIso8601(i.fecha,'YYYY')==transformarIso8601(item.fecha,'YYYY')).reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
    const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    //return {text:`Total año ${transformarIso8601(item.fecha,'YYYY')} ${total_formateado}`}
    const fecha = new Date(item.fecha);
    
    return 	{
        fontSize: 10,
        bold:true,
        margin:[0,10,0,10],
        columns: [
            {
                width: 50,
                text: 'TOTAL'
            },
            {
                width: 60,
                text: `Año  ${fecha.getFullYear()}`
            },
            {
                width: 335,
                canvas: [{ type: 'line', x1: 0, y1: 5, x2: 335, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
            },
            {
                width: 85,
                background:bkmonto,alignment:'right',
                table: {
                    widths:[85],
                    body: [
                        [{text:total_formateado,alignment:'right'}],
                    ]
                }
            },
        ]
    }
}

function imprimirTotalGeneral(item,index,vector){
    const total = vector.reduce((ac,valor)=>{return ac = ac + valor.monto_numerico},0)
    const total_formateado = total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
   // return {text:`Total: ${total_formateado}`}

    return 	{
        fontSize: 10,
        bold:true,
        margin:[0,10,0,10],
        columns: [
            {
                width: 50,
                text: 'TOTAL'
            },
            {
                width: 395,
                canvas: [{ type: 'line', x1: 0, y1: 5, x2: 395, y2: 5, lineWidth: 0.5,lineColor: 'black' }],
            },
           /* {
                width: 100,
                text: ``
            },
            {
                width: 100,
                text: ``
            },
            {
                width: 100,
                text: ``
            },*/
            {
                width: 85,
                background:bkmonto,alignment:'right',
                table: {
                    widths:[85],
                    body: [
                        [{text:total_formateado,alignment:'right'}],
                    ]
                }
            },
        ]
    }
}

